import React from 'react';
import ReactDOM from 'react-dom';

import { Game, getApiPath } from "common";
import { stateFix } from "logic/stateReducers";

import Store from 'store';

import EditingContext from 'store/editingContext';
import { IconLibrary } from 'components/IconLibrary';
import { ModifierContext } from 'ui/modifiers';

async function _loadProfile(id, dataLoaded) {
  const url = getApiPath(`profiles/load/${Game}/${id}`);
  const result = await fetch(url).then((response) => response.json());

  if (!result || result.error || !result.data) {
    throw Error(result?.error || `Unknown error`);
  }

  if (dataLoaded) await dataLoaded;
  return stateFix(JSON.parse(result.data));
}

const buildCache = {};
export function loadProfile(id, dataLoaded) {
  if (buildCache[id]) return buildCache[id];
  return buildCache[id] = _loadProfile(id, dataLoaded);
}

function profileIndex(state, set) {
  if (!set ) return -1;
  if (!isNaN(set)) {
    const idx = parseInt(set) - 1;
    if (state.profiles[idx]) return idx;
  }
  return state.profiles.findIndex(profile => profile.name === set);
}

const ecMap = new Map();
export async function renderProfile(node, id, set, component, dataLoaded) {
  let state = await loadProfile(id, dataLoaded);
  if (!state.profiles) throw Error('profile not found');
  if (dataLoaded) await dataLoaded;

  const store = new Store();
  const index = profileIndex(state, set);
  if (index >= 0) {
    state = {...state, activeProfile: index};
  }
  await store.setState(state);

  const profile = state.profiles[state.activeProfile];
  if (!ecMap.get(profile)) {
    ecMap.set(profile, new EditingContext());
  }

  ReactDOM.render((
    <Store.Provider store={store}>
      <IconLibrary>
        <ModifierContext>
          <EditingContext.Provider context={ecMap.get(profile)}>
            {component}
          </EditingContext.Provider>
        </ModifierContext>
      </IconLibrary>
    </Store.Provider>
  ), node);
}
